export default __webpack_public_path__ + "static/ebook-4c0591aee2722f2031470d7fe4b53816.png";